var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"phone-input"}},[_c('VuePhoneNumberInput',{attrs:{"no-example":"","no-validator-state":"","required":_vm.required,"translations":{
            countrySelectorLabel: _vm.$t('code'),
            phoneNumberLabel: _vm.$t('phone'),
        },"defaultCountryCode":_vm.countryCode},on:{"update":_vm.onUpdate},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }